import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import HideValue from '../../RestrictedAccess/HideValue';

const PRZText = ({
  isInternalLink,
  isExternalLink,
  className,
  text,
  internalUrl,
  externalUrl,
  onClick,
  required,
  style,
  infoMessage,
  infoMessageStyle = {
    marginLeft: '5px',
    color: 'grey',
    cursor: 'pointer',
  },
  hideText,
  popOverMessage,
}) => {
  return (
    <div className={className} style={style} onClick={onClick}>
      { (isInternalLink || isExternalLink)
        ? (
          <Link to={internalUrl || externalUrl}>
            {hideText ? <HideValue showPopOver popOverMessage={popOverMessage} /> : text}
          </Link>
        )
        : (hideText ? <HideValue showPopOver popOverMessage={popOverMessage} /> : text)}
      { required && <span style={{ color: 'red', marginLeft: '2px' }}>*</span>}
      {infoMessage && (
        <Tooltip title={infoMessage}>
          <InfoCircleOutlined
            style={infoMessageStyle}
          />
        </Tooltip>
      )}
    </div>
  );
}

export default PRZText;
